import { render, staticRenderFns } from "./AssistantBubble.vue?vue&type=template&id=686f1f1e&scoped=true"
import script from "./AssistantBubble.vue?vue&type=script&lang=js"
export * from "./AssistantBubble.vue?vue&type=script&lang=js"
import style0 from "./AssistantBubble.vue?vue&type=style&index=0&id=686f1f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686f1f1e",
  null
  
)

export default component.exports